
import { FC } from 'react';

const LocationSection: FC = () => {
  return (
    <section id="location" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-600 mb-4">
            찾아오시는 길
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            편리한 교통과 함께 찾아오세요
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* 지도 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.5234567890123!2d126.9519!3d37.4763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca1b7c9b7c9b7%3A0x1234567890abcdef!2z7ISc7Jq47Yq567OE7IucIOq0gOyVheq1rCDrtJnsspzrj5kgMTYyNS0xNw!5e0!3m2!1sko!2skr!4v1234567890123"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="815광복점 위치"
            />
          </div>

          {/* 매장 외관 및 내부 사진 */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/a1b9186b2007cadc504d1a7218d14f26/fb34263f1d79ca12deb004e53e5b4c31.jpeg"
                alt="815광복점 매장 외관"
                className="w-full h-48 object-cover object-center"
              />
              <div className="p-4">
                <h3 className="text-lg font-bold text-blue-600 mb-2">매장 외관</h3>
                <p className="text-green-600 text-sm">깔끔하고 모던한 외관으로 쉽게 찾을 수 있습니다</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/a1b9186b2007cadc504d1a7218d14f26/de498d337d51ce20c991c5c97c680df3.jpeg"
                alt="815광복점 입구"
                className="w-full h-48 object-cover object-center"
              />
              <div className="p-4">
                <h3 className="text-lg font-bold text-blue-600 mb-2">매장 입구</h3>
                <p className="text-green-600 text-sm">따뜻하고 편안한 분위기로 손님을 맞이합니다</p>
              </div>
            </div>
          </div>
        </div>

        {/* 상세 정보 카드들 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-gradient-to-r from-red-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-white text-xl"></i>
            </div>
            <h3 className="font-bold text-purple-600 mb-2">주소</h3>
            <p className="text-orange-600 text-sm">서울 관악구 봉천동 1625-17</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-gradient-to-r from-red-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-subway-line text-white text-xl"></i>
            </div>
            <h3 className="font-bold text-purple-600 mb-2">지하철</h3>
            <p className="text-orange-600 text-sm">서울대입구역 1번출구 800M<br />낙성대역 4번출구 500M</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-gradient-to-r from-red-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-white text-xl"></i>
            </div>
            <h3 className="font-bold text-purple-600 mb-2">전화번호</h3>
            <p className="text-orange-600 text-sm">02-883-8150</p>
          </div>
        </div>

        {/* 랜드마크 안내 */}
        <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-red-600 mb-6 text-center">식당주변</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-school-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-teal-600 mb-2">인헌초등학교</h4>
              <p className="text-indigo-600 text-sm">정문 맞은편에 위치</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-teal-600 mb-2">샤로수길</h4>
              <p className="text-indigo-600 text-sm">맛집 거리 중심가</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tree-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-teal-600 mb-2">낙성대 공원</h4>
              <p className="text-indigo-600 text-sm">식사후 산책코스</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
